import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadAniversariantes = () => {
  const dataTh: IDataTh[] = [
    { title: "Nome", align: "left", width: "220px", minWidth: "160px" },
    { title: "Dia aniversário", align: "center", width: "120px", minWidth: "100px" },
    { title: "Dias p/ aniversário", align: "center", width: "120px", minWidth: "100px" },
    { title: "Função", align: "left", width: "120px", minWidth: "100px" },
    { title: "Tipo", align: "left", width: "120px", minWidth: "120px" },
    { title: "Email", align: "left", width: "200px", minWidth: "140px" },
    { title: "Telefone", align: "left", width: "140px", minWidth: "120px" },
    { title: "Data de criação", align: "center", width: "160px", minWidth: "140px" },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
